import { Message, Spin, Upload } from "@arco-design/web-react";
import { UploadItem } from "@arco-design/web-react/es/Upload";
import { useState } from "react";
import { IconUpload } from "@arco-design/web-react/icon";
import { getOssFileUrl, getOssUploadTicket, getUploadFileInfo } from "@/services/common";
import "./index.less";

interface AiUploadProps {
  value?: any[];
  onChange?: (value: any[]) => void;
  children?: React.ReactNode;
  maxCount?: number;
  boxStyle?: React.CSSProperties;
  accept?: string;
  maxSize?: number;
}
const AiUpload: React.FC<AiUploadProps> = (props) => {
  const {
    value = [],
    onChange,
    maxCount = Number.MAX_SAFE_INTEGER,
    children,
    boxStyle,
    accept,
    maxSize = Number.MAX_SAFE_INTEGER,
  } = props;

  // 参数
  const [loading, setLoading] = useState<boolean>(false); // 上传loading

  // 方法
  const commEvent = {
    // 上传前校验文件大小
    handleBeforeUpload: (file: File) => {
      const { size } = file;
      if (size > maxSize) {
        Message.error({
          content: `文件大小超过${maxSize / 1024 / 1024}MB，请选择较小的文件。`,
          duration: 2000,
        });
        return false;
      }
      return true;
    },
    // 上传文件
    handleUpload: async (_: UploadItem[], file: UploadItem) => {
      const { name, size } = file.originFile;
      setLoading(true);
      if (file.status === "uploading") {
        let _result = [];
        const ticketInfo = await getOssUploadTicket({ name, size });
        const { data: ossTicket } = ticketInfo?.data || {};
        const fileInfo = await getUploadFileInfo({ ticket: ossTicket, file: file.originFile });
        const { object_key = "" } = fileInfo?.data?.data || {};
        const res = await getOssFileUrl({ oss_key: object_key });
        if (res?.data?.code === 0) {
          if (maxCount === 1) {
            _result = [{ uid: file.uid, object_key, url: res?.data?.data?.url || "" }];
          } else {
            _result = [...value, { uid: file.uid, object_key, url: res?.data?.data?.url || "" }];
          }
        }
        onChange?.(_result);
        setLoading(false);
      }
    },
  };

  return (
    <div>
      {/* 文件展示 */}
      {value.map((item, index) => (
        <div key={index} style={{ ...boxStyle, backgroundImage: `url(${item.url})` }} className="ai_upload_content">
          {item.url?.includes("mp4") && <video src={item.url} className="ai_upload_content" />}
          {/* 单文件上传 */}
          {maxCount === 1 && (
            <>
              {loading ? (
                <div className="upload_content_spin">{<Spin />}</div>
              ) : (
                <Upload
                  onChange={commEvent.handleUpload}
                  listType="picture-card"
                  showUploadList={false}
                  accept={accept}
                  beforeUpload={commEvent.handleBeforeUpload}
                >
                  <div className="upload_content_mask">
                    <IconUpload className="content_mask_icon" />
                    <div className="content_mask_text">上传文件</div>
                  </div>
                </Upload>
              )}
            </>
          )}
        </div>
      ))}
      {/* 多文件上传 */}
      {Array.isArray(value) && value.length < maxCount && (
        <Spin loading={loading}>
          <Upload
            onChange={commEvent.handleUpload}
            listType="picture-card"
            showUploadList={false}
            accept={accept}
            beforeUpload={commEvent.handleBeforeUpload}
          >
            {children}
          </Upload>
        </Spin>
      )}
    </div>
  );
};

export default AiUpload;
